import { useEffect, useState } from "react";
import { useTradeInAemSelector } from "../redux/store";
import { getNavStepIndex } from "../utils/navUtils";
import { useTradeInCsl } from "../csl/tradeInCslUtils";

type UseTradeInAemNavigation = {
    currentStep: number;
    navigationOpen: boolean;
    setNavigationOpen: (open: boolean) => void;
};

const useTradeInAemNavigation = (): UseTradeInAemNavigation => {
    const step = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const [navigationOpen, setNavigationOpen] = useState<boolean>(false);
    const csl = useTradeInCsl();

    const currentStep = getNavStepIndex(csl, step) + 1;

    // Close the nav menu when changing the step without a reload.
    useEffect(() => {
        setNavigationOpen(false);
    }, [step]);

    return {
        currentStep,
        navigationOpen,
        setNavigationOpen,
    };
};

export default useTradeInAemNavigation;
